export default {
    characters: "tegn",
    choice: "valg",
    chooseCountry: "Velg land",
    city: "Poststed",
    courseSelection: "linje",
    draftEmailButtonCancel: "Avbryt",
    draftEmailButtonSend: "Send",
    draftEmailHeadline: "Skriv inn e-posten din",
    draftEmailText: "Skriv inn e-posten din for å få lenke du kan bruke for å fullføre søknaden senere.",
    draftErrorSubmitted: "Søknaden er allerede sendt inn.",
    errorNoOpenCourses: "Beklager, skolen har ingen ledige plasser.",
    errorNoOpenCoursesHeadline: "Ingen ledige plasser",
    formButtonAddCourse: "Legg eventuelt til flere valg her",
    formButtonSaveDraft: "Lagre kladd",
    formButtonSubmit: "Send søknad",
    formChooseFile: "Velg fil",
    formDefaultOptionCourse: "Linjefag",
    formDefaultOptionCourse2: "Linjefag",
    formDefaultOptionCoursePlus: "Prosjektfag",
    formDraftUrlLink: "Få lenke på e-post",
    formDraftUrlText: "Vil du fullføre søknaden senere?",
    formErrorCourse: "Du må velge en linje.",
    formErrorDate: "Ugyldig dato.",
    formErrorEmail: "Ugyldig epost.",
    formErrorPhone: "Ugyldig telefonnummer.",
    formErrorRequired: "Du må fylle inn",
    formErrorRequiredAlternative: "Du må velge minst ett alternativ.",
    formErrorRequiredCountry: "Du må velge et land.",
    formErrorRequiredDate: "Du må velge en dato.",
    formErrorRequiredFile: "Du må laste opp en fil.",
    formErrorRequiredGeneric: "Dette feltet er påkrevd.",
    formErrorRequiredSocialSecurity: "Du må fylle inn fødsels- og personnummer",
    formErrorRequiredZip: "Du må fylle inn postnummer.",
    formErrorSocialSecNr: "Ugyldig fødselsnummer. Har du ikke norsk personnummer, skriv inn fødselsdato med 6 siffer i formatet DDMMÅÅ",
    formErrorZip: "Ugyldig postnummer.",
    formExplanationApply: "Søknaden er helt uforpliktende, og du kan takke nei hvis du skulle ombestemme deg.",
    formExplanationCourse: "Er det noen flere linjer du kan tenke deg å søke på denne skolen?",
    formExplanationSoonFinished: "Nå er du snart i mål! Se raskt over søknaden før du sender den inn.",
    formHeadline: "Hvilken type linje vil du søke på?",
    formHeadlineCourse: "Hvilken linje vil du gå på?",
    formHeadlineCourse1: "Hvilken linje vil du ha som linjefag 1?",
    formHeadlineCourse2: "Hvilken linje vil du ha som linjefag 2?",
    formHeadlineCoursePlus: "Hvilket prosjektfag ønsker du?",
    formHeadlineSummary: "Nå er du snart i mål! Se raskt over søknaden før du sender den inn.",
    formHeadlineSummaryCoursePlus: "Prosjektfag",
    formHeadlineSummaryCourses: "Linjer",
    formHeadlineSummarySchool: "Skole",
    formIntroRequired: "Felter markert med <span>*</span> må fylles ut",
    formMessageSubmittedSuccess: "Søknaden er innsendt!",
    formNorwegianCitizen: "Norsk",
    formOtherCitizen: "Annet",
    formPageNext: "Gå videre",
    formPageNextHint: "Snart i mål! Gå videre og se over søknaden før du sender den inn.",
    formPagePrevious: "Gå tilbake",
    formRecieptText: "Skriv ut søknaden",
    formSubmitHeadline: "Send inn",
    formSubmitIntro: 'Trykk på "Søk" for å sende inn søknaden din.',
    formSubmitSuccessHeadline: "Søknaden er sendt inn!",
    formSubmitSuccessText: "Takk for din søknad. Skolen vil kontakte deg om kort tid.",
    formSubmittingText: "Sender søknaden",
    max: "Maks",
    no: "Nei",
    optional: "valgfritt",
    phoneNumber: "Telefonnummer",
    readMoreAboutSchool: "Les mer om skolen",
    yes: "Ja",
    zipcode: "Postnummer",
};